import { types } from "../actions";

const initialState = {
  pageNumber: 1,
};

const eventPageNumberReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.EVENT_PAGENUMBER:
      return {
        pageNumber : action.payload,
      };
    default:
      return state;
  }
};

export default eventPageNumberReducer;
